import { Skeleton, Stack } from '@mui/material';
import React from 'react';

export default function ReportContentSkeletonPlaceholder({ height }: { height: number }) {
    return (
        <Stack sx={{ height: '100%' }} direction={'column'} justifyContent={'stretch'}>
            <Skeleton sx={{ height: `${height}px`, width: '100%' }} animation="wave" variant="rectangular" />
        </Stack>
    );
}
